import Drawer from '../drawer';

export function init() {
	let drawer = Drawer('filter-drawer');

	if (!drawer) {
		return;
	}
}
